import { defineMessages } from 'react-intl'
import { invertObjectUtil } from 'packages/src'

export const LEVEL = {
  BEGINNER: 1,
  INTERMEDIATE: 2,
  ADVANCED: 3,
  EXPERT: 4
}

export const LEVEL_TO_KEY = invertObjectUtil(LEVEL)

export const LEVEL_TO_SEARCH_BEGINNER_QUERY_ARR = [
  'beginner'
]

export const LEVEL_TO_SEARCH_INTERMEDIATE_QUERY_ARR = [
  'intermediate'
]

export const LEVEL_TO_SEARCH_ADVANCED_QUERY_ARR = [
  'advanced'
]

export const LEVEL_TO_SEARCH_EXPERT_QUERY_ARR = [
  ...LEVEL_TO_SEARCH_ADVANCED_QUERY_ARR
]

export const LEVEL_TO_SEARCH_QUERY_ARR_TO_IGNORE = {
  [LEVEL.BEGINNER]: [
    ...LEVEL_TO_SEARCH_INTERMEDIATE_QUERY_ARR,
    ...LEVEL_TO_SEARCH_ADVANCED_QUERY_ARR,
    ...LEVEL_TO_SEARCH_EXPERT_QUERY_ARR
  ],
  [LEVEL.INTERMEDIATE]: [
    ...LEVEL_TO_SEARCH_BEGINNER_QUERY_ARR,
    ...LEVEL_TO_SEARCH_ADVANCED_QUERY_ARR,
    ...LEVEL_TO_SEARCH_EXPERT_QUERY_ARR
  ],
  [LEVEL.ADVANCED]: [
    ...LEVEL_TO_SEARCH_BEGINNER_QUERY_ARR,
    ...LEVEL_TO_SEARCH_INTERMEDIATE_QUERY_ARR,
    ...LEVEL_TO_SEARCH_EXPERT_QUERY_ARR
  ],
  [LEVEL.EXPERT]: [
    ...LEVEL_TO_SEARCH_BEGINNER_QUERY_ARR,
    ...LEVEL_TO_SEARCH_INTERMEDIATE_QUERY_ARR
  ]
}

export const LEVEL_TO_SEARCH_QUERY_ARR = {
  [LEVEL.BEGINNER]: LEVEL_TO_SEARCH_BEGINNER_QUERY_ARR,
  [LEVEL.INTERMEDIATE]: LEVEL_TO_SEARCH_INTERMEDIATE_QUERY_ARR,
  [LEVEL.ADVANCED]: LEVEL_TO_SEARCH_ADVANCED_QUERY_ARR,
  [LEVEL.EXPERT]: LEVEL_TO_SEARCH_EXPERT_QUERY_ARR
}

const label = defineMessages({
  beginner: {
    id: 'level.beginner',
    defaultMessage: 'Beginner'
  },
  intermediate: {
    id: 'level.intermediate',
    defaultMessage: 'Intermediate'
  },
  advanced: {
    id: 'level.advanced',
    defaultMessage: 'Advanced'
  },
  expert: {
    id: 'level.expert',
    defaultMessage: 'Expert'
  }
})

const LEVEL_MESSAGE = {
  [LEVEL.BEGINNER]: label.beginner,
  [LEVEL.INTERMEDIATE]: label.intermediate,
  [LEVEL.ADVANCED]: label.advanced,
  [LEVEL.EXPERT]: label.expert
}

const helperMessages = defineMessages({
  beginner: {
    id: 'level.beginnerHelper',
    defaultMessage: 'You are just starting out.',
    description: 'The second label used for the beginner fitness level.'
  },
  intermediate: {
    id: 'level.intermediateHelper',
    defaultMessage: 'You know how to perform exercises with good form.',
    description: 'The second label used for the intermediate fitness level.'
  },
  advanced: {
    id: 'level.advancedHelper',
    defaultMessage: 'You know how to work out effectively.',
    description: 'The second label used for the advanced fitness level.'
  },
  expert: {
    id: 'level.expertHelper',
    defaultMessage: 'You know exactly what you’re doing.',
    description: 'The second label used for the expert fitness level.'
  }
})

const LEVEL_MESSAGE_HELPER = {
  [LEVEL.BEGINNER]: helperMessages.beginner,
  [LEVEL.INTERMEDIATE]: helperMessages.intermediate,
  [LEVEL.ADVANCED]: helperMessages.advanced,
  [LEVEL.EXPERT]: helperMessages.expert
}

export {
  LEVEL_MESSAGE,
  LEVEL_MESSAGE_HELPER
}
